const CONSENT_CATEGORIES = ['necessary', 'measurement', 'marketing'];
const CONSENT_DISABLED_POLICY = {
  id: 'consent_disabled_kill_switch',
  match: {
    isDefault: true
  },
  model: 'opt-out',
  prompt: 'none'
};

export { CONSENT_CATEGORIES, CONSENT_DISABLED_POLICY };
